<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="next"><img alt="" src="image/1.png"/></p>
<p class="Body_EPI">The young man who has not wept is a savage, and the old man who will not laugh <span class="noBreak">is a fool.</span></p>
<p class="Body_EPIS">—George Santayana 1863–1952<br/>Spanish-American philosopher</p>
<p class="Body_EPI">When it comes to shaping our decisions and our actions, feeling counts every bit as much—and often more—tha<span class="noBreak">n thought.</span></p>
<p class="Body_EPIS _idGenParaOverride-1">—Daniel Goleman<br/>American psychologist</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NothingsWrong-4.vue?0bff81fa